import { CONTENT } from '../content/runtime.js';

/** Early departures use the current operator's bounded cruise time. */
export function departureTripFrames(baseFrames: number, departureOffset: number, visiting: boolean): number {
    const earlyFrames = Math.max(0, -departureOffset);
    if (earlyFrames === 0) return baseFrames;
    const minimum = visiting ? 0.4 : 0.5, reduction = visiting ? 0.6 : 0.5;
    return Math.max(360, Math.round(baseFrames * Math.max(minimum, 1 - earlyFrames / (45 * CONTENT.balance.constants.AIRPORT_MINUTE) * reduction)));
}
